import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { Provincia } from "../../../../common/models/tipologiche/provincia";
import { SoggettoPratica } from '../../../../common/models/tipologiche/soggetto-pratica';
import { TipoTipologica } from "../../../../common/models/tipologiche/tipo-tipologica";

export class FascicoloOpposaiserviziispettivi extends FascicoloFull {
  dataApertura: number;
  dataNotificaAtto: number;
  societa: SoggettoPratica;
  opposizione: boolean;
  organoIspettivo: TipoTipologica;
  provincia: Provincia;
  tipoProvvedimento: TipoTipologica;
  constructor() {
    super();
    this.dataApertura = + new Date();
    this.dataInizioFascicolo = + new Date();
  }
}
